// extracted by mini-css-extract-plugin
export var reg = "style-module--reg--52d0c";
export var wrap = "style-module--wrap--17263";